import { Directive, forwardRef, ComponentFactoryResolver, ViewContainerRef, Input, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ValueAccessorBase, AbpFieldDisplayLabelComponent, AbpLabelComponent, AbpLinkButtonControlComponent, AbpResetButtonControlComponent, AbpTransIconButtonControlComponent, AbpTransButtonControlComponent, AbpIconButtonControlComponent, AbpSubmitButtonControlComponent, AbpButtonControlComponent, AbpDatepickerComponent, AbpSingleSelectDropdownComponent, AbpRadioListInlineComponent, AbpSwitchComponent, AbpRadioButtonListComponent, AbpCheckBoxListControlComponent, AbpCheckBoxControlComponent, AbpPasswordControlComponent, AbpTextBoxControlComponent } from '@colibrium/abp-form-control';
import { FieldModel, FieldType } from '@colibrium/abp-base';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/attr-directive/abp-custom-field.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#region core imports
//#endregion core imports
//#region functional/model imports
//#endregion functional/model imports
import * as ɵngcc0 from '@angular/core';
class AbpCustomFieldModel extends FieldModel {
    //#endregion model properties
    //#region event handler properties
    //#endregion event handler properties
    //#region read only properties
    //#endregion read only properties
    //#region constructor
    constructor() {
        super();
    }
}
if (false) {
    /** @type {?} */
    AbpCustomFieldModel.prototype.componentName;
    /** @type {?} */
    AbpCustomFieldModel.prototype.componentClass;
    /** @type {?} */
    AbpCustomFieldModel.prototype.componentInputModel;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/attr-directive/abp-dynamic-field.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
class AbpDynamicFieldDirective extends ValueAccessorBase {
    //#endregion model properties
    //#region constructor
    /**
     * @param {?} resolver
     * @param {?} container
     */
    constructor(resolver, container) {
        super();
        this.resolver = resolver;
        this.container = container;
    }
    //#endregion constructor
    //#region component events
    /**
     * @return {?}
     */
    ngOnInit() {
        this.setComponent();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if ((changes.isFormSubmitted && changes.isFormSubmitted.previousValue != changes.isFormSubmitted.currentValue) ||
            (changes.field && changes.field.previousValue != changes.field.currentValue)) {
            if (this.component) {
                this.component.instance.isFormSubmitted = this.isFormSubmitted;
                this.component.instance.field = this.field;
                if (this.component.instance.runChangeDetection) {
                    this.component.instance.runChangeDetection();
                }
            }
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
    }
    //#endregion component events
    //#region public functions
    //#endregion public functions
    //#region private functions
    /**
     * sets component for field
     * @private
     * @return {?}
     */
    setComponent() {
        if (this.field) {
            switch (this.field.fieldControlType) {
                case FieldType.Textbox:
                    this.component = this.getComponentRef(AbpTextBoxControlComponent);
                    this.component.instance.field = (/** @type {?} */ (this.field));
                    break;
                case FieldType.Password:
                    this.component = this.getComponentRef(AbpPasswordControlComponent);
                    this.component.instance.field = (/** @type {?} */ (this.field));
                case FieldType.Checkbox:
                    this.component = this.getComponentRef(AbpCheckBoxControlComponent);
                    this.component.instance.field = (/** @type {?} */ (this.field));
                    break;
                case FieldType.CheckboxList:
                    this.component = this.getComponentRef(AbpCheckBoxListControlComponent);
                    this.component.instance.field = (/** @type {?} */ (this.field));
                    break;
                case FieldType.RadioList:
                    this.component = this.getComponentRef(AbpRadioButtonListComponent);
                    this.component.instance.field = (/** @type {?} */ (this.field));
                    break;
                case FieldType.Switch:
                    this.component = this.getComponentRef(AbpSwitchComponent);
                    this.component.instance.field = (/** @type {?} */ (this.field));
                    break;
                case FieldType.RadioInlineList:
                    this.component = this.getComponentRef(AbpRadioListInlineComponent);
                    this.component.instance.field = (/** @type {?} */ (this.field));
                    break;
                case FieldType.Dropdown:
                    this.component = this.getComponentRef(AbpSingleSelectDropdownComponent);
                    this.component.instance.field = (/** @type {?} */ (this.field));
                    break;
                case FieldType.Date:
                    this.component = this.getComponentRef(AbpDatepickerComponent);
                    this.component.instance.field = (/** @type {?} */ (this.field));
                    break;
                case FieldType.Button:
                    this.component = this.getComponentRef(AbpButtonControlComponent);
                    this.component.instance.field = (/** @type {?} */ (this.field));
                    break;
                case FieldType.SubmitButton:
                    this.component = this.getComponentRef(AbpSubmitButtonControlComponent);
                    this.component.instance.field = (/** @type {?} */ (this.field));
                    break;
                case FieldType.IconButton:
                    this.component = this.getComponentRef(AbpIconButtonControlComponent);
                    this.component.instance.field = (/** @type {?} */ (this.field));
                    break;
                case FieldType.TransparentButton:
                    this.component = this.getComponentRef(AbpTransButtonControlComponent);
                    this.component.instance.field = (/** @type {?} */ (this.field));
                    break;
                case FieldType.TransparentIconButton:
                    this.component = this.getComponentRef(AbpTransIconButtonControlComponent);
                    this.component.instance.field = (/** @type {?} */ (this.field));
                    break;
                case FieldType.ResetButton:
                    this.component = this.getComponentRef(AbpResetButtonControlComponent);
                    this.component.instance.field = (/** @type {?} */ (this.field));
                    break;
                case FieldType.LinkButton:
                    this.component = this.getComponentRef(AbpLinkButtonControlComponent);
                    this.component.instance.field = (/** @type {?} */ (this.field));
                    break;
                case FieldType.Label:
                    this.component = this.getComponentRef(AbpLabelComponent);
                    this.component.instance.field = (/** @type {?} */ (this.field));
                    break;
                case FieldType.FieldDisplayLabel:
                    this.component = this.getComponentRef(AbpFieldDisplayLabelComponent);
                    this.component.instance.field = (/** @type {?} */ (this.field));
                    break;
                case FieldType.custom:
                    /** @type {?} */
                    const factory = this.resolver.resolveComponentFactory(this.customComponent.componentClass);
                    this.component = this.container.createComponent(factory);
                    Array.from(this.customComponent.componentInputModel.entries()).forEach((/**
                     * @param {?} entry
                     * @return {?}
                     */
                    entry => {
                        this.component.instance[entry[0]] = entry[1];
                    }));
                    break;
            }
            if (this.component) {
                this.component.instance.isDynamic = true;
                this.component.instance.id = this.id;
                this.component.instance.isFormSubmitted = this.isFormSubmitted;
                if (this.formControlElement && this.component.instance.control) {
                    this.component.instance.control.next(this.formControlElement);
                }
            }
        }
    }
    /**
     * gets
     * @private
     * @template T
     * @param {?} component
     * @return {?}
     */
    getComponentRef(component) {
        /** @type {?} */
        const factory = this.resolver.resolveComponentFactory(component);
        return this.container.createComponent(factory);
    }
}
AbpDynamicFieldDirective.ɵfac = function AbpDynamicFieldDirective_Factory(t) { return new (t || AbpDynamicFieldDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
AbpDynamicFieldDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AbpDynamicFieldDirective, selectors: [["", "dynamicField", ""]], inputs: { field: "field", isFormSubmitted: "isFormSubmitted", formControlElement: "formControlElement", id: "id", customComponent: "customComponent" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(( /**
                 * @return {?}
                 */() => AbpDynamicFieldDirective)),
                multi: true
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature] });
/** @nocollapse */
AbpDynamicFieldDirective.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: ViewContainerRef }
];
AbpDynamicFieldDirective.propDecorators = {
    field: [{ type: Input }],
    isFormSubmitted: [{ type: Input }],
    formControlElement: [{ type: Input }],
    id: [{ type: Input }],
    customComponent: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbpDynamicFieldDirective, [{
        type: Directive,
        args: [{
                selector: '[dynamicField]',
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(( /**
                         * @return {?}
                         */() => AbpDynamicFieldDirective)),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.ViewContainerRef }]; }, { field: [{
            type: Input
        }], isFormSubmitted: [{
            type: Input
        }], formControlElement: [{
            type: Input
        }], id: [{
            type: Input
        }], customComponent: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    AbpDynamicFieldDirective.prototype.field;
    /** @type {?} */
    AbpDynamicFieldDirective.prototype.isFormSubmitted;
    /** @type {?} */
    AbpDynamicFieldDirective.prototype.formControlElement;
    /** @type {?} */
    AbpDynamicFieldDirective.prototype.id;
    /** @type {?} */
    AbpDynamicFieldDirective.prototype.customComponent;
    /** @type {?} */
    AbpDynamicFieldDirective.prototype.component;
    /**
     * @type {?}
     * @private
     */
    AbpDynamicFieldDirective.prototype.resolver;
    /**
     * @type {?}
     * @private
     */
    AbpDynamicFieldDirective.prototype.container;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/abp-dynamic-form.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion directives
//#region pipes/filter
//#endregion pipes/filters
class AbpDynamicFormModule {
}
AbpDynamicFormModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AbpDynamicFormModule });
AbpDynamicFormModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AbpDynamicFormModule_Factory(t) { return new (t || AbpDynamicFormModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AbpDynamicFormModule, { declarations: function () { return [AbpDynamicFieldDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [AbpDynamicFieldDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbpDynamicFormModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    AbpDynamicFieldDirective
                ],
                entryComponents: [],
                exports: [
                    AbpDynamicFieldDirective
                ]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: colibrium-abp-dynamic-form.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AbpCustomFieldModel, AbpDynamicFieldDirective, AbpDynamicFormModule };

//# sourceMappingURL=colibrium-abp-dynamic-form.js.map